import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { AUTHORITIES } from "../../../constants";
import { ICON_SIZE, TEXT_NORMAL } from "../../../style";
import { hasRequiredAuthority } from "../../../utils";

export const USER_SECTIONS = [
    { title: "Basics", icon: "pi-user", path: "basics" },
    { title: "Notifications", icon: "pi-bell", path: "notifications" },
    { title: "Inquiries", icon: "pi-question", path: "inquiries", requiredAuthority: AUTHORITIES.MANAGE_OTHER_USERS },
    { title: "Enrollments", icon: "pi-folder-open", path: "enrollments" },
    { title: "Exam History", icon: "pi-pencil", path: "exam-history" },
    { title: "Activities", icon: "pi-history", path: "activities" },
    { title: "Batches", icon: "pi-users", path: "batches" },
    { title: "P.C.A.T.", icon: "pi-lightbulb", path: "stream-selection-test-results", requiredAuthority: AUTHORITIES.MANAGE_OTHER_USERS },
    { title: "Devices", icon: "pi-tablet", path: "devices" },
    { title: "Wallet", icon: "pi-wallet", path: "wallet" },
    { title: "Notes", icon: "pi-clipboard", path: "global-notes" },
    { title: "Counseling", icon: "pi-comments", path: "counseling-notes" },
    { title: "Roles", icon: "pi-id-card", path: "roles", requiredAuthority: AUTHORITIES.MANAGE_OTHER_USERS },
];

export default function UserSections() {
    const navigate = useNavigate();
    const { authorities = [] } = useSelector((state) => state.stateUser);

    const sections = useMemo(
        () => USER_SECTIONS.filter((section) => !section.requiredAuthority || hasRequiredAuthority(authorities, section.requiredAuthority)),
        [authorities],
    );

    return (
        <div className="flex-1 min-h-0 overflow-y-auto flex flex-column gap-2 p-2">
            {sections.map(({ title, icon, path }) => (
                <div
                    key={path}
                    className="bg-white border-1 border-gray-300 border-round-md flex align-items-center gap-3 p-3 cursor-pointer"
                    onClick={() => navigate(path)}
                >
                    <i className={`pi ${icon} border-circle bg-gray-800 p-3 text-white ${ICON_SIZE}`} />
                    <span className={`flex-1 font-semibold ${TEXT_NORMAL}`}>{title}</span>
                    <i className="pi pi-angle-right text-color-secondary" />
                </div>
            ))}
        </div>
    );
}
